var _defs, _style, _use;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDownBlackArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 15 9",
    width: 15,
    height: 9,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("image", {
    width: 15,
    height: 9,
    id: "img1",
    href: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA8AAAAJCAMAAADaUYZlAAAAAXNSR0IB2cksfwAAARFQTFRFlpaWSUlJu7u709PTxMTEvr6+tbW1wcHB0tLS2NjY4eHhv7+/tra2TU1Nc3NzOzs7AAAAKSkpubm5zMzMvb2919fX6+vrdHR0HR0dHh4eubm5HR0dJSUlt7e3yMjItLS00NDQOTk5FBQUkpKS6enpwMDAHR0dJycnsLCwvLy82trayMjINzc3ERERl5eXuLi43d3d7+/vxMTEICAgIiIip6enwMDAMTExnZ2du7u7ra2t8fHxw8PDHBwcKysrcXFxKCgoExMTm5ubwMDAr6+v4uLi4+Pj8PDwIiIiCAgIFhYWm5ubsLCw5OTk8/Pzvb29EhISCQkJj4+PwsLC5+fn39/fZ2dnFhYWSUlJoqKiubm5XlVN3gAAAFt0Uk5TMaYpAAAAAAAAAAAAFadHu//VJwAAAAAXwNU74tYkAAAWwfBQADfj0icAABW98k0AAAAz4NgoGMNKAAAANeTRO7nwTAAAAAAA4PnxTQAAADHj8EgAAAA41VIAABVDaWAAAACMSURBVHicY2BgZGJmYWVj5+Dk4ubh5WPgFxAUEhYB8kXFxCUEJBmkpAVkZOXk2Tm4FBQFlJQZVFTVBNQ1NNm1tHUEdPX0GQwMjYwFTEyFzcwFlCwsrRgMuKxtbAXs7B0EHJ2cXYB8Vzd3Gw8BTwEvb242HxDf19XPP0AgMChYHsp3CwkNC4+IjGID8gFXUxVURpIV2QAAAABJRU5ErkJggg=="
  }))), _style || (_style = /*#__PURE__*/React.createElement("style", null)), _use || (_use = /*#__PURE__*/React.createElement("use", {
    href: "#img1",
    x: 0,
    y: 0
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownBlackArrow);
export default __webpack_public_path__ + "static/media/downBlackArrow.2671cabcfcc975d4ff9fcc32f666759d.svg";
export { ForwardRef as ReactComponent };